import { inject, type InjectionKey } from 'vue'
import type { CreateToasterReturn } from '@ark-ui/vue'

export type UiToasterInstance = CreateToasterReturn

export const toasterInjectionKey: InjectionKey<UiToasterInstance> = Symbol('se-toaster')

export function useToaster(): UiToasterInstance {
    const instance = inject(toasterInjectionKey, null)
    if (!instance) {
        throw new Error('[UiToaster] No toaster instance found. Mount <UiToaster /> near the app root before calling useToaster().')
    }
    return instance
}


